import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { apiRequest } from '../../utils/api';

const initialState = {
    data: null,
    isLoading: true,
    error: null
};

export const fetchBankData = createAsyncThunk('data/fetchBankData', async () => {
    try {
        const response = await apiRequest('get', 'banks');
        return response;
    } catch (error) {
        throw error?.response?.data?.message || error?.response?.data || error?.message;
    }
});

const bankSlice = createSlice({
    name: 'bank',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchBankData.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(fetchBankData.fulfilled, (state, action) => {
                state.isLoading = false;
                state.error = null;
                state.data = action.payload?.data;
            })
            .addCase(fetchBankData.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.error;
            });
    }
});

export default bankSlice.reducer;
